module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeView flexRow"
  }, [_c('div', {
    staticClass: "today"
  }, [_c('today-view', {
    attrs: {
      "categories": _vm.categories
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('details-view', {
    attrs: {
      "categories": _vm.categories
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0733ce4!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/HomeView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-b0733ce4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/HomeView.vue
// module chunks = 0